// import { useTranslations } from "next-intl";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Styles from "./Partners.module.css";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";

// IMPORT IMAGES
import logoSvg from "../../assets/Logo.cd2f6a51098336f66c866c2dfe881423.svg";
import clientlogo from "../../assets/clientlogo.jpg";
import logobravo from "../../assets/logobravo.png";
import beyondLogo from "../../assets/Beyond Logo 1.png";
import baa from "../../assets/baa.jpg";
import logoClient from "../../assets/logoClient.png";
import afaqLogo from "../../assets/afaqLogo.png";
import blueLogo from "../../assets/BlueLogo.png";
import malazlogo from "../../assets/malazlogo.png";
import ostalogo2 from "../../assets/ostalogo2.png";
import smilelogo from "../../assets/smilelogo.png";
import groupLogo from "../../assets/Group 1000002787.png";
import yayalogo from "../../assets/yayalogo.png";
import logo1 from "../../assets/logo1.png";

function Index({ state }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const logos = [
    logoSvg,
    clientlogo,
    logobravo,
    beyondLogo,
    baa,
    logoClient,
    afaqLogo,
    blueLogo,
    malazlogo,
    ostalogo2,
    smilelogo,
    groupLogo,
    yayalogo,
    logo1,
  ];

  return (
    <div className={Styles.serviceContainer}>
      <div className={Styles.title}>
        <h3>{currentLocal.general.partnersTitle}</h3>
      </div>

      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlaySpeed={2000}
        autoPlay={true}
        arrows={false}
      >
        {logos.map((logo, index) => (
          <div className={Styles.card} key={index}>
            <img
              src={logo}
              alt="logo"
              style={{ width: "180px" }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default Index;